import { PRIORITY_TERM, tripStage } from '../constants/trip.constants'

function getLocalityLabel({ city, state = '' }) {
	return state.trim() ? `${city} (${state})` : city
}

const tripSearchHelper = {
	getLocalityLabel,
}

export default tripSearchHelper

export function getViewableLocations(locations) {
	if (!locations || locations.length === 0) {
		return []
	}

	let newLocations = locations.map((location) => {
		return {
			id: location.id,
			value: location.ibgeCode,
			label: !!location.state
				? `${location.city} (${location.state})`
				: location.city,
			city: location.city,
		}
	})

	newLocations = sortTerminalsByPriority(newLocations, PRIORITY_TERM)

	return newLocations
}

export function getViewableLocation(location) {
	return !!location
		? {
				id: location.id,
				value: location.ibgeCode,
				label: !!location.state
					? `${location.city} (${location.state})`
					: location.city,
				city: location.city,
		  }
		: null
}

export function getDestinyDefaultValue(
	selectedOrigin,
	selectedDestiny,
	destinyOptions
) {
	if (!selectedOrigin || (selectedOrigin && !selectedOrigin.label)) {
		return tripStage.DESTINY
	}
	if (!destinyOptions || (!!destinyOptions && destinyOptions.length === 0)) {
		return 'Nenhuma viagem encontrada'
	}
	if (!selectedDestiny || (!!selectedDestiny && !selectedDestiny.label)) {
		return 'Selecione destino'
	} else {
		return selectedDestiny.label
	}
}

export function getDateFormatted(date) {
	if (!!date) {
		return date.toISOString().split('T')[0]
	}
	return ''
}

export function sortTerminalsByPriority(list, priorityTerm) {
	return list.sort((a, b) => {
		let bKey = b.label || b.city
		let aKey = a.label || a.city
		return bKey.includes(priorityTerm) - aKey.includes(priorityTerm)
	})
}
